import { generateUuid, Uuid } from '@ftr/contracts/type/shared'
import { TransactionResult } from './operation-result'

export interface DeleteRemarkOperation {
  type: 'deleteRemark'
  remarkId: Uuid
}

export function deleteRemarkTransaction(operation: DeleteRemarkOperation): TransactionResult {
  return {
    type: 'transaction',
    transaction: {
      id: generateUuid(),
      edits: [
        {
          type: 'deleteUtterance',
          utteranceId: operation.remarkId,
        },
      ],
    },
    sideEffects: [],
  }
}
